export const enum PatientsTagsEnum {
  UNINVITED = 'Uninvited',
  WELCOMED = 'Welcome mail sent',
  QUESTIONNAIRE_SENT = 'Questionnaire Sent',
  RESPONSE_RECEIVED = 'Response Received',
  NURSE_APPOINTMENT_REQUEST_SENT = 'Nurse Appointment Request Sent',
  NURSE_APPOINTMENT_TAKEN = 'Nurse Appointment Taken',
  DOCTOR_APPOINTMENT_REQUEST_SENT = 'Doctor Appointment Request Sent',
  DOCTOR_APPOINTMENT_TAKEN = 'Doctor Appointment Taken',
  REPORT_SENT = 'Report Sent',
}

export const allPatientsTagsEnum = [
  PatientsTagsEnum.UNINVITED,
  PatientsTagsEnum.WELCOMED,
  PatientsTagsEnum.QUESTIONNAIRE_SENT,
  PatientsTagsEnum.RESPONSE_RECEIVED,
  PatientsTagsEnum.NURSE_APPOINTMENT_REQUEST_SENT,
  PatientsTagsEnum.NURSE_APPOINTMENT_TAKEN,
  PatientsTagsEnum.DOCTOR_APPOINTMENT_REQUEST_SENT,
  PatientsTagsEnum.DOCTOR_APPOINTMENT_TAKEN,
  PatientsTagsEnum.REPORT_SENT,
]

export const enum PatientsLanguagesEnum {
  NL = 'Nederlands',
  FR = 'Français',
  EN = 'English',
}

export const enum RecoveryKeyOutcomeEnum {
  RECOVERY = 'recovery',
  NO_RECOVERY = 'no_recovery',
  RECOVERY_ALREADY_DONE = 'recovery_already_done',
  INVALID_KEY = 'invalid_key',
}
